var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M303.002 410.442L165.677 267.117C161.627 262.317 159.977 257.817 159.977 253.992C159.977 250.167 161.641 245.014 164.993 241.549L303.002 97.5492C309.827 90.3522 321.902 90.1182 328.427 97.0092C335.646 103.853 335.88 115.294 328.966 122.442L202.877 253.992L328.877 385.542C335.791 392.667 335.556 404.127 328.338 410.974C321.902 417.867 309.827 417.642 303.002 410.442Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftIcon);
export default __webpack_public_path__ + "static/media/arrow-left-icon.f3f0371463a9be7938278510862150e9.svg";
export { ForwardRef as ReactComponent };